<template>
    <div>
        <search-header />
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(item,index) in bannerList" :key="index">
                <img class="img-style" :src="item.url" />
            </van-swipe-item>
<!--            <van-swipe-item><img class="img-style" src="../../assets/banner1.jpg" /> </van-swipe-item>-->
<!--            <van-swipe-item><img class="img-style" src="../../assets/banner2.jpg" /></van-swipe-item>-->
        </van-swipe>
<!--        <div class="category-list">-->
<!--            <div>-->
<!--                <img src="../../assets/s1.png" />-->
<!--                <span class="category-text">生鲜</span>-->
<!--            </div>-->
<!--            <div>-->
<!--                <img src="../../assets/s2.png" />-->
<!--                <span class="category-text">水果</span>-->
<!--            </div>-->
<!--            <div>-->
<!--                <img src="../../assets/s3.png" />-->
<!--                <span class="category-text">采摘</span>-->
<!--            </div>-->
<!--            <div>-->
<!--                <img src="../../assets/s4.png" />-->
<!--                <span class="category-text">露营</span>-->
<!--            </div>-->
<!--            <div>-->
<!--                <img src="../../assets/s5.png" />-->
<!--                <span class="category-text">民宿</span>-->
<!--            </div>-->
<!--        </div>-->
        <div>
            <product-list />
        </div>
        <div style="padding: 40px">&nbsp;</div>
        <partner-footer p_active="0" />
    </div>
</template>

<script>
    import SearchHeader from "../../components/Header/SearchHeader";
    import PartnerFooter from "../../components/Footer/PartnerFooter";
    import ProductList from "../../components/Product/ProductList";
    import store from '@/store';
    import config from '@/config';
    import { mapActions } from 'vuex';

    export default {
        name: "Home",
        components: {ProductList, PartnerFooter, SearchHeader},
        comments:{
            PartnerFooter,
            SearchHeader,
            ProductList,
        },
        data(){
            return{
                mode:config.mode,
                bannerList:[],
            }
        },
        methods:{
            ...mapActions([
                'GetAppBanner',
            ]),
            loadBanner(){
                let mode=config.mode;
                this.GetAppBanner({mode}).then(res=>{
                    this.bannerList=res;
                })
            }
        },
        mounted() {
            this.loadBanner();
        },
        beforeRouteEnter(to, from, next){
            let loginUser = store.getters.getLoginUser;
            if(loginUser&&loginUser.openid){
                next();
            }else{
                if(config.mode===2){
                    //耘径联盟，到join去
                    //未登录则跳到join页
                    next({path:'/join'})
                }else{
                    //梅唐四季，则直接提示授权登录
                    //未登录，则发起微信登录授权
                    let code = to.query.code;
                    let sales_uid='';   //首页授权登录不带渠道号
                    let mode=1; //梅唐四季模式
                    if(code){
                        store.dispatch('WeixinLogin',{code,sales_uid,mode}).then(res=>{
                            if(res.status>0){
                                //登录失败
                                next(false);
                            }else{
                                //成功
                                next();
                            }
                        });
                    }else{
                        //无code则表示是第一次进入本页，发起微信授权
                        // let redirect_uri=encodeURIComponent(config.weixin.redirect_dev); //debug
                        let redirect_uri = encodeURIComponent(window.location.href);
                        let appid=config.weixin.appid_mt;
                        let state=''; //'product-detail-sale/1004/1002'; //debug
                        let auth_url= 'https://open.weixin.qq.com/connect/oauth2/authorize?' +
                            'appid=' +appid+
                            '&redirect_uri=' +redirect_uri+
                            '&response_type=code&scope=snsapi_userinfo&' +
                            'state=' +state+
                            '#wechat_redirect';
                        // console.log('weixin auth url',auth_url);
                        window.location.href = auth_url;
                    }
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .img-style{
        max-height: 340px;
        width: 100%;
        margin-top: 0;
    }

    .category-list {
        display: flex;
        flex-shrink: 0;
        flex-wrap: wrap;
        width: 100%;
        padding-bottom: 26px;
        div {
            display: flex;
            flex-direction: column;
            width: 20%;
            text-align: center;
            img {
                width: 50px;
                height: 50px;
                margin: 10px auto 10px auto;
            }
        }
    }

    .category-text{
        font-size: 14px;
        color: #666;
    }

</style>